"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactGa = require("react-ga");

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _zIndex = _interopRequireDefault(require("../../../constants/z-index"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

var _BrandButton = _interopRequireDefault(require("../../Button/BrandButton"));

var _OutlineButton = _interopRequireDefault(require("../../Button/OutlineButton"));

var _ButtonGroup = _interopRequireDefault(require("../../ButtonGroup"));

var _UnitInput = _interopRequireDefault(require("./UnitInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: #fafdff;\n\tborder-top: 1px solid #0a223333;\n\tmargin: 0;\n\tpadding: ", " ", " 0;\n\tjustify-content: space-between;\n\n\t@media (min-width: ", ") {\n\t\tpadding: ", " ", " ", ";\n\t}\n\n\t@media (max-width: ", ") {\n\t\tbutton {\n\t\t\tmargin-bottom: ", ";\n\t\t}\n\t}\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: row;\n\tbackground-color: white;\n\tpadding: ", ";\n\talign-items: center;\n\tjustify-content: center;\n\n\t@media (min-width: ", ") {\n\t\tpadding: ", ";\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: 50px;\n\tz-index: ", ";\n\twidth: 220px;\n\tbox-shadow: ", ";\n\tborder: 2px solid ", ";\n\tborder-radius: ", ";\n\n\t@media (min-width: ", ") {\n\t\twidth: 320px;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: ", " ", ";\n\tfont-size: ", ";\n\tdisplay: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Separator = _styledComponents.default.span(_templateObject(), _spacing.default.s2, _spacing.default.s3, _spacing.default.s3);

Separator.displayName = 'Separator';

var Overlay = _styledComponents.default.div(_templateObject2(), _zIndex.default.OVERLAY, _vars.default.boxShadow, _colors.default.borderFocus, _vars.default.borderRadius, _breakpoints.default.tablet);

Overlay.displayName = 'Overlay';

var Content = _styledComponents.default.div(_templateObject3(), _spacing.default.s2, _breakpoints.default.tablet, _spacing.default.s3);

Content.displayName = 'Content';
var DialogButtonGroup = (0, _styledComponents.default)(_ButtonGroup.default)(_templateObject4(), _spacing.default.s1, _spacing.default.s1, _breakpoints.default.tablet, _spacing.default.s2, _spacing.default.s2, _spacing.default.s1, _breakpoints.default.tablet, _spacing.default.s1);
DialogButtonGroup.displayName = 'DialogButtonGroup';

var OverlayBase = function OverlayBase(_ref) {
  var value = _ref.value,
      onHide = _ref.onHide,
      hourIncrements = _ref.hourIncrements,
      minuteIncrements = _ref.minuteIncrements,
      GA = _ref.GA,
      _onIncrement = _ref.onIncrement,
      _onChange = _ref.onChange,
      onApply = _ref.onApply;
  var hideCallback = (0, _react.useCallback)(onHide, [onHide]);
  (0, _react.useEffect)(function () {
    var handleEsc = function handleEsc(e) {
      if (e.keyCode === 27) {
        hideCallback();
      }
    };

    window.addEventListener('keydown', handleEsc);
    return function () {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [hideCallback]);
  var hours = value.hours,
      minutes = value.minutes;
  return _react.default.createElement(Overlay, null, _react.default.createElement(Content, null, _react.default.createElement(_UnitInput.default, {
    unit: "hours",
    value: hours,
    onChange: function onChange(newValue, shouldApply) {
      return _onChange(newValue, 'hours', shouldApply);
    },
    onIncrement: function onIncrement(i) {
      return _onIncrement(i, 'hours');
    },
    increment: hourIncrements
  }), _react.default.createElement(Separator, null, ":"), _react.default.createElement(_UnitInput.default, {
    unit: "minutes",
    value: minutes,
    onChange: function onChange(newValue, shouldApply) {
      return _onChange(newValue, 'minutes', shouldApply);
    },
    onIncrement: function onIncrement(i) {
      return _onIncrement(i, 'minutes');
    },
    showLargeIncrements: minuteIncrements <= 15,
    increment: minuteIncrements
  })), _react.default.createElement(DialogButtonGroup, {
    reverseColumnOrder: true
  }, _react.default.createElement(_OutlineButton.default, {
    type: "button",
    onClick: function onClick() {
      onHide();

      if (GA) {
        (0, _reactGa.event)({
          category: GA.category,
          action: GA.action + " (Cancel)"
        });
      }
    }
  }, "Cancel"), _react.default.createElement(_BrandButton.default, {
    type: "button",
    onClick: function onClick() {
      onApply(value);
      onHide();

      if (GA) {
        (0, _reactGa.event)({
          category: GA.category,
          action: GA.action + " (Apply)",
          label: hours + " hrs " + minutes + " mins"
        });
      }
    },
    "data-e2e": "time-apply"
  }, "Apply")));
};

OverlayBase.propTypes = {
  value: (0, _propTypes.shape)({
    hours: _propTypes.number,
    minutes: _propTypes.number
  }).isRequired,
  onChange: _propTypes.func.isRequired,
  onApply: _propTypes.func.isRequired,
  onHide: _propTypes.func.isRequired,
  onIncrement: _propTypes.func.isRequired,
  minuteIncrements: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),
  hourIncrements: _propTypes.number,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    action: _propTypes.string
  })
};
OverlayBase.defaultProps = {
  minuteIncrements: 1,
  hourIncrements: 1,
  GA: undefined
};
var _default = OverlayBase;
exports.default = _default;